import React, { useEffect, useState } from "react";
import Select from "react-select";
import { optionsReceiptTime } from '../../common/constant';

const MobileHeaderSarang = (props) => {
    const { handleSortChange, headCell, setOrder, setOrderBy, getList, getSumary, searchData, configLocal } = props;
    const [headCellSort, setHeadCellSort] = useState([]);

    useEffect(() => {
        var sortColumn = [];
        headCell && headCell.map((row) => {
            if (!row.disablePadding) {
                sortColumn.push({ value: row.id + " asc", label: row.label + " (tăng dần)" });
                sortColumn.push({ value: row.id + " desc", label: row.label + " (giảm dần)" })
            }
        });
        setHeadCellSort(sortColumn);
    }, []);

    const handleDataSortChange = (sortData) => {
        if (!sortData) return;
        setOrder(sortData.value.includes("desc") ? "desc" : "asc");
        setOrderBy(sortData.value.replace("desc", "").replace("asc", ""));
        handleSortChange(sortData.value);
    };

    return <div className="card">
        <div className="d-flex align-items-center">
            <div className="list-group-item list-group-item-action flex-column align-items-start collapsed" style={{ border: "none" }}
                data-toggle="collapse" aria-expanded="false" >
                <div className="row">
                    {
                        getList || getSumary ? <>
                            <Select
                                isClearable
                                //{...register("receiptTime", {})}
                                placeholder="Thời gian nhận"
                                closeMenuOnSelect={true}
                                onChange={(data) => getList ? getList(1, configLocal.defaultPageSize, configLocal.sortExpression, data = { ...searchData, receiptTime: data ? data.value : null }) : getSumary ? getSumary(data = { ...searchData, receiptTime: data ? data.value : null }) : null}
                                options={optionsReceiptTime}
                                noOptionsMessage={() => "Không tồn tại"}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                isSearchable={false}
                            />
                        </> : <>
                            <div className="col-3">
                                Sắp xếp
                            </div>
                            <div className="col-9">
                                <Select
                                    onChange={(data) => {
                                        handleDataSortChange(data);
                                    }}
                                    isClearable
                                    isSearchable={false}
                                    options={headCellSort}
                                    noOptionsMessage={() => "Không tồn tại"}
                                    // style để dropdown đè absolute lên cả body thay vì bị giới hạn chỉ trong table
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </div>
                        </>
                    }
                    
                </div>
            </div>
        </div>
    </div>
}

export default MobileHeaderSarang;